import * as t from "io-ts";
import nullable from "./nullable";
import { trailerTypeT, fuelTypeT, vehicleTypeT, vehicleCo2EmissionsClassT, } from "./types";
export const createTrailerTypes = ({ decimal, }) => {
    const baseTrailerT = t.strict({
        qualities: nullable(t.array(t.string)),
        number: t.string,
        type: trailerTypeT,
        lm: decimal,
        height: decimal,
        width: decimal,
        length: decimal,
        weight: nullable(decimal),
        volume: nullable(decimal),
        note: nullable(t.string),
        department: nullable(t.string),
        powered: t.boolean,
        deviationPercentage: nullable(decimal),
        kmPerLiter: nullable(decimal),
        fuelType: nullable(fuelTypeT),
        vehicleType: nullable(vehicleTypeT),
        trackerDeviceId: nullable(t.string),
        departmentId: nullable(t.string),
        alias: nullable(t.string),
        color: nullable(t.string),
        trailerWeight: nullable(decimal),
        co2EmissionsClass: nullable(vehicleCo2EmissionsClassT),
    });
    const updateTrailerT = t.intersection([
        baseTrailerT,
        t.strict({ id: t.string }),
    ]);
    const trailerT = t.intersection([
        updateTrailerT,
        t.strict({ teams: t.array(t.string) }),
    ]);
    const trailersT = t.array(trailerT);
    return { baseTrailerT, trailerT, updateTrailerT, trailersT };
};
//# sourceMappingURL=trailers.js.map